// The router matches paths case-insensitively and decodes percent-encoded letters, so a link
// spelled either way still opens the page; the pattern accepts both spellings of each letter.
const matchLiteralOrEncoded = (text: string): string =>
  [...text]
    .map((char) => {
      const encodings = [...new Set([char.toLowerCase(), char.toUpperCase()])].map(
        (variant) => `%${variant.charCodeAt(0).toString(16)}`
      )
      return `(?:${char}|${encodings.join('|')})`
    })
    .join('')

const PAYMENT_APPROVAL_PATH_PATTERN = new RegExp(
  `/${matchLiteralOrEncoded('p')}/${matchLiteralOrEncoded('payment-approval')}/[^/?#]+`,
  'i'
)

const REDACTED_PAYMENT_APPROVAL_PATH = '/p/payment-approval/redacted'

export const OPENED_PAYMENT_APPROVAL_SEGMENT = 'opened'

export const OPENED_PAYMENT_APPROVAL_PATH = `/p/payment-approval/${OPENED_PAYMENT_APPROVAL_SEGMENT}`

export const isPaymentApprovalPath = (pathname: string): boolean =>
  PAYMENT_APPROVAL_PATH_PATTERN.test(pathname)

export const redactPaymentApprovalToken = (url: string): string =>
  url.replace(PAYMENT_APPROVAL_PATH_PATTERN, REDACTED_PAYMENT_APPROVAL_PATH)

const PUBLIC_FORM_PATH_PATTERN = new RegExp(
  `/${matchLiteralOrEncoded('p')}/${matchLiteralOrEncoded('form')}/[^/?#]+`,
  'i'
)

export const isPublicFormPath = (pathname: string): boolean =>
  PUBLIC_FORM_PATH_PATTERN.test(pathname)

const PENDING_ITEMS_PATH_PATTERN = new RegExp(
  `/${matchLiteralOrEncoded('p')}/${matchLiteralOrEncoded('pending')}(?:[/?#]|$)`,
  'i'
)

export const isPendingItemsPath = (pathname: string): boolean =>
  PENDING_ITEMS_PATH_PATTERN.test(pathname)

const SALE_HANDOFF_PATH_PATTERN = new RegExp(
  `/${matchLiteralOrEncoded('p')}/${matchLiteralOrEncoded('sale')}(?:[/?#]|$)`,
  'i'
)

export const isSaleHandoffPath = (pathname: string): boolean =>
  SALE_HANDOFF_PATH_PATTERN.test(pathname)

export const isUntrackedCapabilityPath = (pathname: string): boolean =>
  isPaymentApprovalPath(pathname) ||
  isPublicFormPath(pathname) ||
  isPendingItemsPath(pathname) ||
  isSaleHandoffPath(pathname)
